/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import * as authServices from '../services/authService'
import * as accountServices from '../services/accountService'
import * as eventService from '../services/eventService'
import * as utilService from '../services/utilService'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LoginPopup from './sub_components/loginpopup'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import * as stringParser from '../util/string.util'
import * as dateUtil from '../util/date.util'
import { ReCAPTCHA_KEY } from '../configs/const';
import ReCAPTCHA from "react-google-recaptcha";
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import UnderMaintenance from './under_maintenance';
import {BRANDLOGOFILENAME} from '../configs/authSignupConfig';
import {showAdminBannerLink, showBHMBannerLink} from '../configs/casinoShowList';

let oid = OPERATOR_ID.toLowerCase()
const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class Auth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            passcode: "",
            date: "",
            showToast: false,
            toastMsg: "",
            toastType: "",
            passVisible: false,
            showDownLoad: false,
            rememberMe: false,
            inMaitanence: false,
            inMaitanenceMessage: '',
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            clientWidth: document.documentElement.clientWidth,
            showPopup: false
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    componentWillMount() {
        utilService.checkMaintainanceCall().then((res) => {
            if (res.isSuccess && !!res.items && res.items.isMaintenance) {
                this.setState({
                    inMaitanence: true,
                    inMaitanenceMessage: res.items
                })
            }
        })
    }

    async componentDidMount() {
        localStorage.removeItem('videoSplashScreenVisited');
        localStorage.removeItem("homeData")
        localStorage.removeItem("userAuthDetail")
        localStorage.removeItem("tokenData")
        if (this.state.inMaitanence) {
            return false
        }
        if (constants.isDev) {
            this.setState({ isDev: true })
        }
        let savedData = localStorage.getItem("rememberData")
        if (!!savedData) {
            savedData = JSON.parse(savedData)
            if (!!savedData && !!savedData.uid) {
                this.setState({ rememberMe: true, uid: savedData.uid, passcode: !!savedData.passcode ? savedData.passcode : "" })
            }
        }
        if (!window.location.href.includes("apk")) {
            this.setState({ showDownLoad: true })
            localStorage.setItem("appType", "web")
        } else {
            localStorage.setItem("appType", "mobile")
        }
        eventService.getBaseHomeData().then((res) => {
            let homeData = this.parseBook(res)
            localStorage.setItem('homeData', JSON.stringify(homeData))
            localStorage.setItem('isBaseData', "true")
        })


        // headers.append('Referrer-Policy', 'origin');
        // options.referrerPolicy = 'no-referrer-when-downgrade'; Referrer-Policy "origin"
        // headers.append('Accept', '*/*');
        // headers.append('Access-Encoding', 'gzip, deflate, br');
        // headers.append('Connection', 'keep-alive');
        var options = {};
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Origin', '*');
        options.headers = headers;




        // let banners = await utilService.getBanner()
        // let banners = await utilService.getBannerListJson()
        // debugger
        if(showAdminBannerLink){
            utilService.getOperatorBannerListJson().then((res) => {
                if (!!res) {
                    let desktop_banners_arr = res.desktop
                    let mobile_banners_arr = res.mobile
    
                    let desktop_banners = {}
                    for (var banner of desktop_banners_arr) {
                        desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/desktop_banner_${banner}`
                    }
    
                    let mobile_banners = {}
                    for (var mobbanner of mobile_banners_arr) {
                        mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/mobile_banner_${mobbanner}`
                    }
                    
                    this.setState({ operatorDesktopBanners: desktop_banners, operatorMobileBanners: mobile_banners },()=>{
                        if(showBHMBannerLink){
                            utilService.getBannerListJson().then((res) => {
                                if (!!res) {
                                    let desktop_banners_arr = res.desktop
                                    let mobile_banners_arr = res.mobile
                                    
                                    let desktop_banners = {}
                                    for (var banner of desktop_banners_arr) {
                                        desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
                                    }
                                    let mobile_banners = {}
                                    for (var mobbanner of mobile_banners_arr) {
                                        mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
                                    }
                    
                                    this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
                                }
                            })
                        }
                    })
                }
            })
        } else { 
            if(showBHMBannerLink){ 
                utilService.getBannerListJson().then((res) => {
                    if (!!res) {
                        let desktop_banners_arr = res.desktop
                        let mobile_banners_arr = res.mobile

                        let desktop_banners = {}
                        for (var banner of desktop_banners_arr) {
                            desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
                        }

                        let mobile_banners = {}
                        for (var mobbanner of mobile_banners_arr) {
                            mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
                        }

                        this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
                    }
                })
            }
        }

        // if (!!banners.items && banners.items.length > 0 && banners.isSuccess) {

        //     let desktop_banners_arr = banners.items.filter((banner) => { return banner.includes("desktop_banner") })
        //     let mobile_banners_arr = banners.items.filter((banner) => { return banner.includes("mobile_banner") })

        //     let desktop_banners = {}
        //     for (var banner of desktop_banners_arr) {
        //         desktop_banners[banner.split("_")[2].split(".")[0]] = banner
        //     }

        //     let mobile_banners = {}
        //     for (var mobbanner of mobile_banners_arr) {
        //         mobile_banners[mobbanner.split("_")[2].split(".")[0]] = mobbanner
        //     }

        //     this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        // }
    }

    parseBook(data) {
        !!data && data.length > 0 && data.forEach((mkt, i) => {
            // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
            let eventMeta = {}
            eventMeta.hasBookMaker = !!mkt.metadata && !!mkt.metadata.hasBookMaker && mkt.metadata.hasBookMaker === "True" ? "true" : "false"
            eventMeta.hasSession = !!mkt.metadata && !!mkt.metadata.hasSession && mkt.metadata.hasSession === "True" ? "true" : "false"
            eventMeta.hasTv = !!mkt.metadata && !!mkt.metadata.hasTv && mkt.metadata.hasTv === "True" ? "true" : "false"
            let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz(mkt.metadata.book) : null
            if (mkt.eventType.id === "300") {
                data[i].displayMarketNameTime = dateUtil.getBinaryMarketDisplayName(mkt.catalogue.marketName)
                data[i].symbolType = !!mkt.metadata && !!mkt.metadata.symbol_type ? mkt.metadata.symbol_type : null
                data[i].eventId = mkt.event.id
                data[i].eventName = mkt.event.name
                data[i].competitionName = mkt.competition.name
            }
            // const market_end_time = !!mkt.metadata && !!mkt.metadata.market_end_time ? mkt.metadata.market_end_time : null
            data[i].metadata = {}
            data[i].metadata.book = book
            data[i].metadata.eventMeta = eventMeta
            // if(!!market_end_time){
            //     data[i].metadata.market_time = moment(mkt.catalogue.marketTime).format('HH:mm')
            //     data[i].metadata.market_end_time = moment(new Date(parseInt(market_end_time)).toLocaleString()).format("HH:mm")
            // }
        })
        return data
    }

    showPopup() {
        this.setState({ showPopup: true })
    }
    hidePopup() {
        this.setState({ showPopup: false })
    }

    loginSuccess() {
        this.setState({ showPopup: false })
        window.location.href = "/home"
    }

    setPassword() {
        this.setState({ showPopup: false })
        this.props.history.push("/setpassword");
    }

    notify(msg, type) {
        this.props.notify(msg, type)
    }

    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }

    // onChange(e) {
    //     const name = e.target.name;
    //     const value = e.target.value;
    //     this.setState({ [name]: value })
    // }

    // handleKey(e) {
    //     if (e.keyCode === 13) {
    //         this.signIn();
    //     }
    // }

    // signIn() {
    //     let body = {
    //         "username": this.state.uid.trim().toLowerCase(),
    //         "password": this.state.passcode
    //     }
    //     if (!this.state.uid.trim()) {
    //         this.props.notify("Please Insert Username!", "error")
    //         return false
    //     }
    //     if (!this.state.passcode) {
    //         this.props.notify("Please Insert Password!", "error")
    //         return false
    //     }
    //     if (this.state.rememberMe) {
    //         let data = {
    //             "uid": this.state.uid.trim().toLowerCase(),
    //             "passcode": this.state.passcode
    //         }
    //         localStorage.setItem("rememberData", JSON.stringify(data))
    //     } else {
    //         localStorage.removeItem("rememberData")
    //     }
    //     authServices.signin(body).then(async (result) => {
    //         if (result.token) {
    //             let data = {
    //                 token: result.token
    //             }
    //             let accessControl = {
    //                 sports: true,
    //                 binary: true,
    //                 casino: true
    //             }
    //             localStorage.setItem("userAuthDetail", JSON.stringify(data))
    //             let velidateData = await authServices.velidateToken()

    //             if (!!velidateData.role && velidateData.role === "Client") {
    //                 localStorage.setItem("tokenData", JSON.stringify(velidateData))
    //                 localStorage.setItem("accessControl", JSON.stringify(accessControl))
    //                 let accData = await accountServices.getAccountData()
    //                 if(!!accData && !!accData.userLock && accData.userLock){
    //                     this.props.notify("User Is Locked. Please Contact Upperline!", "error")
    //                     this.logout()
    //                 }
    //                 localStorage.setItem("accountData", JSON.stringify(accData))
    //                 let configData = await authServices.getConfigButton()
    //                 localStorage.setItem("buttonsValues", JSON.stringify(configData))
    //                 if (velidateData.pwdch) {
    //                     this.props.history.push("/setpassword");
    //                 }
    //                 else {
    //                     // this.props.history.push("/home");
    //                     window.location.href = "/home"
    //                 }
    //             } else if (!!velidateData.role && velidateData.role !== "Client") {
    //                 this.props.notify(velidateData.role + " user is not allow to access this portal.", "error")
    //             } else {
    //                 this.props.notify(velidateData.exception.message, "error")
    //             }
    //         } else {
    //             this.props.notify(result.exception.message, "error")
    //         }
    //     })
    // }

    logout() {
        let appType = localStorage.getItem("appType")
        let rememberData = localStorage.getItem("rememberData")
        localStorage.clear()
        localStorage.setItem("rememberData", rememberData)
        if (appType === "mobile") {
            window.location.href = window.location.origin + "/apk";
        } else {
            window.location.href = window.location.origin + "/auth";
        }
    }

    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <>
                {
                    !this.state.inMaitanence ?

                        <div className="radheexch login-background">
                            <div className='logindesktopview1'></div>
                            <div className='loginnew'>
                                {/* header Start */}
                                <header className="headermobileshow">
                                    <div className="container-fluid">
                                        {/* {this.state.isDev && <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV</span>} */}
                                        <div className="row">
                                            <div className="col-6 col-sm-6 col-md-6 col-lg-6 float-left">
                                                <div className="logo">
                                                    <a href=""><img src={`${BASE_IMAGE_PATH}/${oid}/uimg/${BRANDLOGOFILENAME}`} className="brandlogo" alt="logo" /></a>
                                                </div>
                                            </div>
                                            <div className="col-6 col-sm-6 col-md-6 col-lg-6 loginbtn-center ">
                                                <button className='loginbtnnew' onClick={() => { this.showPopup() }}>
                                                    <i className="fa fa-user-circle-o"></i><span className='d-block'>Login</span></button>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                                {/*END header Start */}
                                {/* Banner Start */}
                                <section className="banner">
                                    <div id="carouselExampleIndicators" className="carousel slide desktop" data-ride="carousel">
                                        <div className="carousel-inner">
                                            <Slider {...settings}>
                                                {Object.keys(this.state.operatorDesktopBanners).length > 0 && Object.keys(this.state.operatorDesktopBanners).map((key) => {
                                                    return (
                                                        <div className="img-slider" key={key}>
                                                            <img style={{ width: "100%" }} src={this.state.operatorDesktopBanners[key]} alt={""}></img>
                                                        </div>
                                                    )
                                                })}
                                                
                                                {Object.keys(this.state.desktopBanners).length > 0 && Object.keys(this.state.desktopBanners).map((key) => {
                                                    return (
                                                        <div className="img-slider" key={key}>
                                                            <img style={{ width: "100%" }} src={this.state.desktopBanners[key]} alt={""}></img>
                                                        </div>
                                                    )
                                                })}
                                                {Object.keys(this.state.operatorDesktopBanners).length === 0 && Object.keys(this.state.desktopBanners).length === 0 &&
                                                    <div className="img-slider">
                                                        <img style={{ width: "100%" }} src={BASE_IMAGE_PATH + "/casino/banner/desktopdefaultbanner.jpg"} alt={""}></img>
                                                    </div>
                                                }
                                            </Slider>
                                        </div>
                                    </div>
                                    <div id="carouselExampleIndicators" className="carousel slide mobile" data-ride="carousel">
                                        <div className="carousel-inner">
                                            <Slider {...settings}>
                                                {Object.keys(this.state.operatorMobileBanners).length > 0 && Object.keys(this.state.operatorMobileBanners).map((key) => {
                                                    return (
                                                        <div className="img-slider" key={key}>
                                                            <img className="bannerimgmobile" style={{ width: "100%" }} src={this.state.operatorMobileBanners[key]} alt={""}></img>
                                                        </div>
                                                    )
                                                })}

                                                {Object.keys(this.state.mobileBanners).length > 0 && Object.keys(this.state.mobileBanners).map((key) => {
                                                    return (
                                                        <div className="img-slider" key={key}>
                                                            <img className="bannerimgmobile" style={{ width: "100%" }} src={this.state.mobileBanners[key]} alt={""}></img>
                                                        </div>
                                                    )
                                                })}
                                                
                                                {Object.keys(this.state.operatorMobileBanners).length === 0 && Object.keys(this.state.mobileBanners).length === 0 &&
                                                    <div className="img-slider">
                                                        <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH + "/casino/banner/mobiledefaultbanner.jpg"} alt={""}></img>
                                                    </div>
                                                }
                                            </Slider>
                                        </div>
                                    </div>
                                </section>
                                {/* END Banner Start */}
                                {/* Middle Start */}
                                <section className='sportbook'>
                                    <div className='container-fluid'>
                                        <div className='row'>
                                            <div className='w-50' onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>
                                                <img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/sport-book-desktop.png"} className="img-fluid sportbook-img desktop" alt="logo" />
                                                <img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/sport-book.png"} className="img-fluid sportbook-img mobile" alt="logo" />
                                            </div>
                                            <div className='w-50 text-right' onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>
                                                <img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/sport-exchange-desktop.png"} className="img-fluid sportbook-img desktop" alt="logo" />
                                                <img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/sport-exchange.png"} className="img-fluid sportbook-img mobile" alt="logo" />
                                            </div>
                                        </div>
                                        <div className='row mt-10'>
                                            <div className='w-25' onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>
                                                <img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/horse-racing.png"} className="img-fluid sportbook-img" alt="logo" />
                                            </div>
                                            <div className='w-25' onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>
                                                <img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/greyhound.png"} className="img-fluid sportbook-img" alt="logo" />
                                            </div>
                                            <div className='w-25' onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>
                                                <img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/binary.png"} className="img-fluid sportbook-img" alt="logo" />
                                            </div>
                                            <div className='w-25' onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>
                                                <img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/virtual-cricket.png"} className="img-fluid sportbook-img" alt="logo" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                {/* END Middle Start */}
                                {/* Casino Start */}
                                <section className='casino-login'>
                                    <div className='container-fluid'>
                                        <div className='logincasino-title2'>Live Casino</div>
                                        <div className='casino-box'>
                                            <div className="casino-login-grid-container2" onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>
                                                <div className="casino-login-grid-item2"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c1.png"} alt="logo" /> </div>
                                                <div className="casino-login-grid-item2"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c2.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c3.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c4.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2 mb-t-7"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c5.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2 mb-t-7"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c6.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2 mt-7 mb-t-7"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c7.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2 mt-7 mb-t-7"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c8.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2 mt-7 mobile-hide-casinoimg"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c9.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2 mt-7 mobile-hide-casinoimg"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c10.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2 mt-7 mobile-hide-casinoimg"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c11.png"} alt="logo" /></div>
                                                <div className="casino-login-grid-item2 mt-7 mobile-hide-casinoimg"><img src={BASE_IMAGE_PATH + "/" + oid + "/loginimages/c12.png"} alt="logo" /></div>
                                            </div>
                                        </div>
                                    </div>

                                </section>
                                {/* END Casino Start */}
                                {/* Footer Start */}
                                <footer>
                                    <div>
                                        {/* <a href="#" target="_blank" rel="noopener noreferrer" className="telegramsicon"><img className="pr-2" src={BASE_IMAGE_PATH + "/casino/banner/images/telegram-icon.png"} alt={""}></img>Connect us on Telegram</a> */}
                                    </div>
                                </footer>
                                {/* END Footer Start */}
                                {this.state.showPopup && <LoginPopup hidePopup={() => { this.hidePopup() }} setPassword={() => { this.setPassword() }} loginSuccess={() => { this.loginSuccess() }} notify={(msg, type) => { this.notify(msg, type) }} logout={() => { this.logout() }} />}
                            </div>
                        </div>
                        :
                        <UnderMaintenance inMaitanenceMessage={this.state.inMaitanenceMessage} />
                }
                {/* <div className='under-maintance'>            
                    <img alt="Under Maintanence"  className="img-fluid" src={BASE_IMAGE_PATH + "/casino/banner/images/undermaintenance.png"} ></img>
                </div> */}
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Auth);